/**
 * Mirror of `MARKET_CATEGORIES` defined in `packages/bot/src/keyboards/inline.ts`.
 *
 * Duplicated (instead of imported) because `packages/webapp` does not depend on
 * `packages/bot` — both consume the same Polymarket Gamma taxonomy and must
 * stay in sync. If you add/remove a category here, mirror the change in the bot
 * (and in every `locales/*.json` + `i18n.ts` `market.cat.<key>` entry).
 *
 * Labels come from i18n via `t('market.cat.' + key)`.
 */
export interface MarketCategory {
  key: string;
  emoji: string;
  /** Polymarket Gamma `/events?tag_slug=…` filter. */
  tagSlug?: string;
  /** Fallback full-text search term when `tagSlug` is absent. */
  query: string;
}

export const MARKET_CATEGORIES: ReadonlyArray<MarketCategory> = [
  { key: 'breaking', emoji: '🔥', tagSlug: 'breaking', query: '' },
  { key: 'politics', emoji: '🏛️', tagSlug: 'politics', query: 'politics' },
  { key: 'trump', emoji: '🇺🇸', query: 'trump' },
  { key: 'crypto', emoji: '💰', tagSlug: 'crypto', query: 'crypto' },
  { key: 'sports', emoji: '⚽', tagSlug: 'sports', query: 'sports' },
  { key: 'elections', emoji: '🗳️', tagSlug: 'elections', query: 'election' },
  { key: 'world', emoji: '🌍', tagSlug: 'world', query: 'world' },
  { key: 'business', emoji: '💼', query: 'business' },
  { key: 'geopolitics', emoji: '🌐', tagSlug: 'geopolitics', query: 'geopolitics' },
  { key: 'finance', emoji: '💵', tagSlug: 'finance', query: 'finance' },
  { key: 'tech', emoji: '💻', tagSlug: 'tech', query: 'tech' },
  { key: 'culture', emoji: '🎬', tagSlug: 'culture', query: 'culture' },
  { key: 'economy', emoji: '📈', tagSlug: 'economy', query: 'economy' },
  { key: 'mentions', emoji: '🗣️', tagSlug: 'mentions', query: 'mentions' },
  { key: 'climate', emoji: '🌤️', tagSlug: 'weather', query: 'climate' },
  { key: 'bonds', emoji: '📊', query: 'bonds' },
];
